<template>
	<div class="this-page">
		<template>
			 <el-button type="primary" style="margin-bottom: 20px;" @click="openAdd()">发行新优惠券</el-button>
			 
		</template>
		<template>
			<el-table :data="list" stripe style="width: 100%" size="small" :height="tableHeight"  border>
				<el-table-column prop="id" label="券编码" width="100" fixed>
				</el-table-column>
				<el-table-column prop="avatar" label="类型" width="100">
					<template slot-scope="scope">
					    <el-tag type="danger" size="small" v-if="scope.row.type == 1">通用运费券</el-tag>
						<el-tag type="success" size="small" v-if="scope.row.type == 2">重量运费券</el-tag>
						<el-tag type="success" size="small" v-if="scope.row.type == 3">体积运费券</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="avatar" label="特殊用途" width="120">
					<template slot-scope="scope">
					    <el-tag type="danger" size="small" v-if="scope.row.reg_auto == 1">注册自动赠送</el-tag>
						
					</template>
				</el-table-column>
        <el-table-column prop="avatar" label="兑换" width="120">
          <template slot-scope="scope">
            <el-tag type="danger" size="small" v-if="scope.row.redeem == 1">{{ scope.row.redeem_integral }}积分兑换</el-tag>
            <el-tag type="info" size="small" v-if="scope.row.redeem == 0">不支持兑换</el-tag>

          </template>
        </el-table-column>
				<el-table-column prop="name" label="券名称" min-width="150">
				</el-table-column>
				
				<el-table-column prop="description" label="描述" min-width="200">
				</el-table-column>
				<el-table-column prop="price" label="券价值" width="100">
				</el-table-column>
				<el-table-column prop="minimum" label="最低消费" width="100">
				</el-table-column>
				<el-table-column prop="days" label="有效期(天)" width="100">
				</el-table-column>
				<el-table-column prop="number" label="发行量" width="100">
				</el-table-column>
				<el-table-column prop="received" label="已领取" width="100">
				</el-table-column>
				<el-table-column prop="used" label="已使用" width="100">
				</el-table-column>
			
				<el-table-column prop="created_at" label="发行时间" width="180">
				</el-table-column>
				<el-table-column prop="created_at" label="操作" width="190" fixed="right">
					<template slot-scope="scope">
					    <el-button type="danger" size="mini" plain round @click="deleted(scope.row.id)">删除</el-button>
						 <el-button type="warning" size="mini" plain round @click="sendCoupon(scope.row.id)">批量发放</el-button>
					</template>
				</el-table-column>
				
			</el-table>
			<template>
				<el-pagination style="margin-top:20px" :current-page="page" background layout="prev, pager, next" :page-count="pageCount"
				 @current-change="pageChange">
				</el-pagination>
			</template>
		</template>
		<template>
			<el-dialog title="发行新优惠券" :visible.sync="showAdd" width="400px">
			  <el-form :model="add">
			    <el-form-item label="券名称" :label-width="formLabelWidth">
			      <el-input v-model="add.name" autocomplete="off" placeholder="请输入券名称" ></el-input>
			    </el-form-item>
				<el-form-item label="券说明" :label-width="formLabelWidth">
				  <el-input v-model="add.description" autocomplete="off" placeholder="请输入券说明" type="textarea"></el-input>
				</el-form-item>
				<el-form-item label="发行量" :label-width="formLabelWidth">
				  <el-input v-model="add.number" autocomplete="off" placeholder="请输入总发行量" ></el-input>
				</el-form-item>
				<el-form-item label="券价值" :label-width="formLabelWidth">
				  <el-input v-model="add.price" autocomplete="off" placeholder="请输入券价值" ></el-input>
				</el-form-item>
				<el-form-item label="有效期" :label-width="formLabelWidth">
				  <el-input v-model="add.days" autocomplete="off" placeholder="请输入有效期天数" ></el-input>
				</el-form-item>
				<el-form-item label="最低消费" :label-width="formLabelWidth">
				  <el-input v-model="add.minimum" autocomplete="off" placeholder="请输入最低消费" ></el-input>
				</el-form-item>
			    <el-form-item label="券类型" :label-width="formLabelWidth">
			      <el-select v-model="add.type" placeholder="请选择类型">
			        <el-option label="通用券" value="1"></el-option>
			        <el-option label="重量券" value="2"></el-option>
					<el-option label="体积券" value="3"></el-option>
			      </el-select>
			    </el-form-item>
				<el-form-item label="用于注册" :label-width="formLabelWidth">
				  <el-select v-model="add.reg" placeholder="是否用于注册">
				    <el-option label="否" value="1"></el-option>
				    <el-option label="是" value="2"></el-option>
				  </el-select>
				</el-form-item>
          <el-form-item label="支持兑换" :label-width="formLabelWidth">
            <el-select v-model="add.redeem" placeholder="是否支持用于积分兑换">
              <el-option label="否" value="1"></el-option>
              <el-option label="是" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="兑换积分" :label-width="formLabelWidth" v-if="add.redeem == 2">
            <el-input v-model="add.redeemIntegral" autocomplete="off" placeholder="请输入兑换消耗积分" ></el-input>
          </el-form-item>
			  </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="showAdd = false">取 消</el-button>
			    <el-button type="primary" @click="addCoupon()">确 定</el-button>
			  </div>
			</el-dialog>
		</template>

	</div>
</template>
<script>
	import toolBar from '../../components/tool-bar/index.vue'
	export default {
		components:{
			toolBar
		},
		data() {
			return {
				tableHeight: document.documentElement.clientHeight - 165 + 'px',
				load: {
					list: false
				},
				page: 1,
				searchValue:'',
				pageCount: 1,
				list: [],
				showAdd:false,
				formLabelWidth:'80px',
				add:{
					name:'',
					type:'',
					description:'',
					price:'',
					minimum:'',
					days:'',
					reg:'',
					number:'',
          redeem:'1',
          redeemIntegral:'1000'
				}
			}
		},
		mounted() {
			var that = this;
			// <!--把window.onresize事件挂在到mounted函数上-->
			window.onresize = () => {
				return (() => {
				  window.fullHeight = document.documentElement.clientHeight;
					
				  that.tableHeight = window.fullHeight - 165 + 'px';  // 高
					
				})()
			  };
			this.getList()
		},
		methods: {
			openAdd(){
				this.add.name = ''
				this.add.type = ''
				this.add.description = ''
				this.add.price = ''
				this.add.minimum = ''
				this.add.days = ''
				this.add.reg = ''
				this.add.number = ''
        this.add.redeem = '1'
        this.add.redeemIntegral = '1000'
				this.showAdd = true
			},
			addCoupon(){
				this.showAdd = false
				this.$fetch.post('Coupon/createCoupon', this.add, true).then(res => {
					this.page = 1
					this.getList()
				})
			},
			getList() {
				this.$fetch.post('Coupon/getCouponList', {
					page: this.page,
					search:this.searchValue
				}, true).then(res => {
					this.load.list = true
					this.list = res.result
					this.pageCount = res.page
				})
			},
			pageChange(e) {
				this.page = e
				this.getList()
			},
			searchOrder(e){
				if(!e){
					this.$message({
						type: 'info',
						message: '当前没有搜索任何信息'
					});  
						return false
				}
				this.searchValue = e
				this.page = 1
				this.getList()

			},
			clearSearch(){
				console.log('清空搜索')
				this.searchValue = ''
				this.page = 1
				this.getList()
			},
			deleted(id){
				this.$confirm('删除优惠券后不可再被领取，不影响已领取优惠券，若删除了系统赠送券，新用户将不再自动发放', '删除优惠券', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				}).then(({ value }) => {
					this.$fetch.post('Coupon/deleteCoupon', {
						id: id
					}, true).then(res => {
						this.$message({
											type: 'success',
											message: '删除成功'
						});   
						this.page = 1
						this.getList()
					})
				}).catch(() => {
				  this.$message({
					type: 'info',
					message: '取消'
				  });       
				});
			},
			adopt(id,owner){
				this.$fetch.post('Group/adoptCreateApply', {
					id: id,
					owner:owner
				}, true).then(res => {
					this.page = 1
					this.getList()
				})
			},
			sendCoupon(id) {
				this.$prompt('请输入起止会员号：格式：10001,10002', '批量发放优惠券', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  inputType:'text'
				}).then(({ value }) => { 
					this.$fetch.post('User/sendCouponBatch', {
						id: id,
						value:value
					}, true).then(res => {
						this.$message({
											type: 'success',
											message: '批量发放成功'
						});   
					
					})
				}).catch(() => {
				  this.$message({
					type: 'info',
					message: '取消'
				  });       
				});
			},
		}
	}
</script>

<style scoped>
	.this-page {
		padding: 10px;
		background-color: #FFFFFF;
	}
</style>
